import axios from 'axios';

export default {
  namespaced: true,
  actions: {
    updatePassword({ commit }, params = {}) {
      return axios.get('/home/ajax/updatePassword', {
        params: params
      }).then((data) => {
        return data;
      });
    }
  },
};
